import { useEffect, useState } from "react";
import API from "../../services/api";
import "./teachers.css";

export default function TeacherLeaveApproval() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const [leaves, setLeaves] = useState([]);

  const downloadReport = () => {
    window.open(
      `${API.defaults.baseURL.replace(/\/$/, "")}/school-admin/teacher-leaves/report/`,
      "_blank"
    );
  };

  const loadLeaves = async () => {
    const res = await API.get("/school-admin/teacher-leaves/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setLeaves(res.data.leaves || []);
  };

  useEffect(() => { loadLeaves(); }, []);

  const handleAction = async (id, action) => {
    await API.post(
      `/school-admin/teacher-leave/action/${id}/`,
      { action },
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );
    alert(`Leave ${action}`);
    loadLeaves();
  };

  const pending  = leaves.filter(l => l.status === "pending");
  const resolved = leaves.filter(l => l.status !== "pending");

  return (
    <div className="teacher-container">

      {/* ══ HERO ══ */}
      <div className="teacher-hero">
        <div>
          <span className="teacher-hero-icon">🗓️</span>
          <h2>Leave Requests</h2>
          <p>
            {pending.length} pending · {resolved.length} resolved
          </p>
        </div>
        <button className="btn-download" onClick={downloadReport}>
          ⬇ Download Report
        </button>
      </div>

      {/* ══ TABLE ══ */}
      <div className="teacher-table-card">
        <table className="teacher-table">
          <thead>
            <tr>
              <th>Teacher</th>
              <th>From</th>
              <th>To</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {leaves.length === 0 ? (
              <tr>
                <td colSpan="6">
                  <div className="teacher-empty-state">
                    <span style={{ fontSize: 44 }}>🗓️</span>
                    <strong>No Leave Requests</strong>
                    <p>All caught up — no pending requests right now.</p>
                  </div>
                </td>
              </tr>
            ) : (
              leaves.map(l => (
                <tr key={l.id}>
                  <td style={{ fontWeight: 700 }}>{l.teacher}</td>
                  <td style={{ fontSize: "13px" }}>{l.from_date}</td>
                  <td style={{ fontSize: "13px" }}>{l.to_date}</td>
                  <td style={{ maxWidth: "200px", fontSize: "13px", color: "#64748b" }}>{l.reason}</td>
                  <td>
                    <span
                      className={`status ${
                        l.status === "approved" ? "present"
                        : l.status === "rejected" ? "absent"
                        : "not-marked"
                      }`}
                    >
                      {l.status.toUpperCase()}
                    </span>
                  </td>
                  <td>
                    {l.status === "pending" && (
                      <>
                        <button
                          className="btn-approve"
                          onClick={() => handleAction(l.id, "approved")}
                        >
                          ✓ Approve
                        </button>
                        <button
                          className="btn-reject"
                          onClick={() => handleAction(l.id, "rejected")}
                        >
                          ✗ Reject
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}
